@use "../../../globals/bcp";

:host {
  display: inline-block;
  // quick fix for Chrome because it was oddly short in chromium engine
  @include bcp.decl(value-modificator, min-width, 15rem, true);
}

.a-text-field-group {
  &--not-allowed {
    cursor: not-allowed;
  }
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
